'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.SKARTOVAN = exports.STORNOVAN = exports.PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = exports.PREDAN_DO_SPISOVNY = exports.UZAVREN = exports.VYRIZEN = exports.NEVYRIZEN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:19:38Z                      #

// ##############################################################

/**
 * Určuje stav, v jakém se spis momentálně nachází. @author Michal Hájek, <a href="mailto:michal.hajek@marbes.cz">michal.hajek@marbes.cz</a> @since 22.05.2017
 */

/**
 * Nevyřízen
 */
var NEVYRIZEN = exports.NEVYRIZEN = 'NEVYRIZEN';

/**
 * Vyřízen
 */
var VYRIZEN = exports.VYRIZEN = 'VYRIZEN';

/**
 * Uzavřen
 */
var UZAVREN = exports.UZAVREN = 'UZAVREN';

/**
 * Předán do spisovny
 */
var PREDAN_DO_SPISOVNY = exports.PREDAN_DO_SPISOVNY = 'PREDAN_DO_SPISOVNY';

/**
 * Předán do archivu nebo skartován
 */
var PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = exports.PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN = 'PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN';

/**
 * Stornován
 */
var STORNOVAN = exports.STORNOVAN = 'STORNOVAN';

/**
 * Skartován
 */
var SKARTOVAN = exports.SKARTOVAN = 'SKARTOVAN';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [NEVYRIZEN, VYRIZEN, UZAVREN, PREDAN_DO_SPISOVNY, PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN, STORNOVAN, SKARTOVAN];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, NEVYRIZEN, { caption: 'Nevyřízen' }), (0, _defineProperty3.default)(_params, VYRIZEN, { caption: 'Vyřízen' }), (0, _defineProperty3.default)(_params, UZAVREN, { caption: 'Uzavřen' }), (0, _defineProperty3.default)(_params, PREDAN_DO_SPISOVNY, { caption: 'Předán do spisovny' }), (0, _defineProperty3.default)(_params, PREDAN_DO_ARCHIVU_NEBO_SKARTOVAN, { caption: 'Předán do archivu nebo skartován' }), (0, _defineProperty3.default)(_params, STORNOVAN, { caption: 'Stornován' }), (0, _defineProperty3.default)(_params, SKARTOVAN, { caption: 'Skartován' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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